import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'zoom', 'Zoom', [["path",{"d":"M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0","key":"svg-0"}],["path",{"d":"M21 21l-6 -6","key":"svg-1"}]]);